import { LegalLayout } from "./components/legalLayout";
import { AVAILABILITY } from "./content/availability";

/** /disponibilidade — nível de serviço e suporte. */
export const Disponibilidade = () => <LegalLayout document={AVAILABILITY} />;
